import { Alert, Header, SpaceBetween } from '@cloudscape-design/components';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';

import {
  listVoiceSalesCalls,
  listVoiceSalesCampaigns,
  listVoiceSalesTargets,
} from '../../common/api/voiceSales';
import { DashboardViewLayout } from '../../components/DashboardViewLayout';
import { OverviewView } from './OverviewView';

export default function VoiceSalesDashboardPage() {
  const navigate = useNavigate();
  const campaignsQuery = useQuery({
    queryKey: ['voice-sales-campaigns'],
    queryFn: () => listVoiceSalesCampaigns(),
  });
  const targetsQuery = useQuery({
    queryKey: ['voice-sales-targets', 'overview'],
    queryFn: () => listVoiceSalesTargets(),
  });
  const callsQuery = useQuery({
    queryKey: ['voice-sales-calls', 'overview'],
    queryFn: () => listVoiceSalesCalls(),
    refetchInterval: 15_000,
  });

  return (
    <DashboardViewLayout
      breadcrumbs={[{ text: 'Voice Sales', href: '/dashboard/voice-sales' }]}
      header={
        <Header variant="h1" description="Run compliant outbound campaigns and review every call.">
          Voice Sales
        </Header>
      }
    >
      <SpaceBetween size="l">
        <Alert type="info" header="Launch safeguards">
          Customer calling is capped at 10 per day. New campaigns stay in preview mode, and every call routes
          only to Max at 940-326-5175 until launch approval. Approved follow-up:
          https://scheduler.zoom.us/adam-alfia/feedback-30. Calendar booking is off and stops safely until
          credentials and scope are approved.
        </Alert>
        <OverviewView
          campaigns={campaignsQuery.data ?? []}
          targets={targetsQuery.data ?? []}
          calls={callsQuery.data ?? []}
          campaignsState={{
            isLoading: campaignsQuery.isPending,
            isError: campaignsQuery.isError,
            refetch: campaignsQuery.refetch,
          }}
          targetsState={{
            isLoading: targetsQuery.isPending,
            isError: targetsQuery.isError,
            refetch: targetsQuery.refetch,
          }}
          callsState={{
            isLoading: callsQuery.isPending,
            isError: callsQuery.isError,
            refetch: callsQuery.refetch,
          }}
          onOpenCampaigns={() => navigate({ to: '/dashboard/voice-sales/campaigns' })}
          onOpenCalls={() => navigate({ to: '/dashboard/voice-sales/calls' })}
          onOpenCall={(callUuid) =>
            navigate({
              to: '/dashboard/voice-sales/calls/$callUuid',
              params: { callUuid },
            })
          }
        />
      </SpaceBetween>
    </DashboardViewLayout>
  );
}
